export default "__VITE_ASSET__Xuq1x5Ii__"